export default [
  {
    year: 2017,
    value: 480,
    group: 'apples'
  },
  {
    year: 2017,
    value: 320,
    group: 'bananas'
  },
  {
    year: 2017,
    value: 640,
    group: 'cherries'
  },
  {
    year: 2017,
    value: 400,
    group: 'dates'
  },
  {
    year: 2018,
    value: 960,
    group: 'apples'
  },
  {
    year: 2018,
    value: 640,
    group: 'bananas'
  },
  {
    year: 2018,
    value: 640,
    group: 'cherries'
  },
  {
    year: 2018,
    value: 400,
    group: 'dates'
  },
  {
    year: 2019,
    value: 1440,
    group: 'apples'
  },
  {
    year: 2019,
    value: 1600,
    group: 'bananas'
  },
  {
    year: 2019,
    value: 960,
    group: 'cherries'
  },
  {
    year: 2019,
    value: 400,
    group: 'dates'
  },
  {
    year: 2020,
    value: 1920,
    group: 'apples'
  },
  {
    year: 2020,
    value: 3840,
    group: 'bananas'
  },
  {
    year: 2020,
    value: 960,
    group: 'cherries'
  },
  {
    year: 2020,
    value: 400,
    group: 'dates'
  }
]